import React, {useContext} from "react";
import {AuthContext} from "./services/auth-context";
import {Navigate} from "react-router-dom";

const PrivateRoute = ({ children }) => {
    const {isUserLoggedIn} = useContext(AuthContext);
    return (isUserLoggedIn() ? children : <Navigate to={"/login"}/>);
}

export default PrivateRoute;